export default __webpack_public_path__ + "static/media/bg-desk-login.62bd4be2.jpg";